import { render } from "./ActivityHome.vue?vue&type=template&id=a0970718&scoped=true"
import script from "./ActivityHome.vue?vue&type=script&lang=js"
export * from "./ActivityHome.vue?vue&type=script&lang=js"

import "./ActivityHome.vue?vue&type=style&index=0&id=a0970718&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0970718"]])

export default __exports__